import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { NotFoundComponentRoutes } from './not-found.routing';
import { NotFoundComponent } from './not-found.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild( NotFoundComponentRoutes )    
   ],
  declarations: [
    NotFoundComponent
  ],
  providers: [ 
  ],
  entryComponents: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})

export class NotFoundModule {}
